module.exports = __webpack_public_path__ + "img/partnership_02.dfbda2ac.jpg";